









import Vue from 'vue';

declare global {
    interface Document {
        mozCancelFullScreen?: () => Promise<void>;
        msExitFullscreen?: () => Promise<void>;
        webkitExitFullscreen?: () => Promise<void>;
        mozFullScreen?: () => Promise<void>;
        webkitIsFullScreen?: () => Promise<void>;
        mozFullScreenElement?: Element;
        msFullscreenElement?: Element;
        webkitFullscreenElement?: Element;
    }

    interface HTMLElement {
        msRequestFullscreen?: () => Promise<void>;
        mozRequestFullscreen?: () => Promise<void>;
        webkitRequestFullscreen?: () => Promise<void>;
    }
}


export default Vue.extend<any, any, any, any>({
	data: () => ({ isFullscreen: false }),
	mounted() {
		document.addEventListener('fullscreenchange', this.fullscreenHandler);
		document.addEventListener('webkitfullscreenchange', this.fullscreenHandler);
		document.addEventListener('mozfullscreenchange', this.fullscreenHandler);
		document.addEventListener('MSFullscreenChange', this.fullscreenHandler);
	},
	beforeDestroy() {
		document.removeEventListener('fullscreenchange', this.fullscreenHandler);
		document.removeEventListener('webkitfullscreenchange', this.fullscreenHandler);
		document.removeEventListener('mozfullscreenchange', this.fullscreenHandler);
		document.removeEventListener('MSFullscreenChange', this.fullscreenHandler);
	},
	methods: {
		openFullscreen() {
			try {
				const element = document.documentElement;
				if (element.requestFullscreen) {
					element.requestFullscreen();
				} else if (element.webkitRequestFullscreen) { /* Safari */
					element.webkitRequestFullscreen();
				} else if (element.msRequestFullscreen) { /* IE11 */
					element.msRequestFullscreen();
				}
			} catch  {
				//
			}
		},
		closeFullscreen() {
			console.log('closeFullscreen');
			try {
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.webkitExitFullscreen) { /* Safari */
					document.webkitExitFullscreen();
				} else if (document.msExitFullscreen) { /* IE11 */
					document.msExitFullscreen();
				}
			} catch  {
				//
			}
		},
		fullscreenHandler() {
			this.isFullscreen = !(!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement);
			this.$emit('fullscreen', this.isFullscreen);
		},
	},
});
